"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class Constants {
}
exports.Constants = Constants;
Constants.DefaultLocalHost = "localhost:7071";
Constants.DefaultLocalOrigin = `http://${Constants.DefaultLocalHost}`;
//# sourceMappingURL=constants.js.map